/**
 * Free-gift order flag (item 10).
 *
 * When the cart reaches the reward threshold, write the configured staff note to the order as the
 * "Free gift" cart attribute, so the fulfilment team knows to include the gift (the giveaway is
 * handled manually, outside Shopify). Clears the attribute again if the cart drops below.
 *
 * Loop-safe: it POSTs to /cart/update.js directly (no section re-render, no cart events dispatched),
 * and only when the desired state differs from what the server last rendered. The reward bar
 * (snippets/gift-progress-bar.liquid) re-renders on every cart merge, keeping the data attributes
 * current, so this just reconciles the order attribute in the background.
 */
(function () {
  const ATTR_KEY = 'Free gift';

  function syncGiftAttribute() {
    const bar = document.querySelector('.clv-reward-bar');
    if (!bar) return;

    const note = bar.dataset.rewardStaffNote || '';
    if (!note) return; // No staff note configured → don't touch order attributes.

    const met = bar.dataset.freeShippingProgress === '1';
    const attrSet = bar.dataset.rewardAttrSet === 'true';
    if (met === attrSet) return; // Already in the desired state.

    const attributes = {};
    attributes[ATTR_KEY] = met ? note : '';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes })
    })
      .then(() => {
        bar.dataset.rewardAttrSet = met ? 'true' : 'false';
      })
      .catch(() => {});
  }

  // Reconcile on load and after every AJAX cart update.
  document.addEventListener('on:cart:after-merge', syncGiftAttribute);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncGiftAttribute);
  } else {
    syncGiftAttribute();
  }
})();
